module.exports = __webpack_public_path__ + "static/media/galleryGT (15).fef8279a.jpg";